module.exports = __webpack_public_path__ + "img/icon_more.c55cb9f4.svg";